<template>
    <div class="p-30 pt-10">

        <div class="flex jc-sb mb-20">
            <el-button size="small">返回</el-button>
        </div>

        <div class="flex jc-sb mb-20">

            <div class="flex jc-fs">
                <div class="t-r pr-5 lh-32">学生姓名：</div>
                <el-input style="width: 300px;" v-model="val" placeholder="请输入姓名"></el-input>

                <div class="ml-20">学号：</div>
                <el-input style="width: 300px;" v-model="val" placeholder="请输入学号"></el-input>
            </div>

            <div>
                <el-button type="primary" @click="search()">
                    <i class="el-icon-search" style="margin-right: 5px;"></i>查询
                </el-button>
                <el-button @click="search('refresh')">
                    <i class="el-icon-refresh" style="margin-right: 5px;"></i>重置
                </el-button>
            </div>

        </div>

        <div class="flex jc-fs mb-20">
            <el-button type="primary" @click="addDialogOpen" plain>
                <i class="el-icon-plus" style="margin-right: 5px;"></i>添加成员
            </el-button>
            <el-button type="primary" plain>
                <i class="el-icon-check" style="margin-right: 5px;"></i>指定组长
            </el-button>
            <el-button type="danger" plain>
                <i class="el-icon-delete" style="margin-right: 5px;"></i>批量移除
            </el-button>
        </div>

        <dyTable v-if="studentList.length > 0" ref="table" :columns="columns" :table-data="studentList"
            v-loading="tableLoading" :total="total" :page-num="pageNo" :page-size="pageSize"
            @current-change="pageNoChange" element-loading-text="加载中">
        </dyTable>

        <el-dialog title="添加组员" :visible.sync="addDialog" width="80%">

            <el-row class="mb-20">
                <el-col :span="14">
                    <div class="t-r pr-5 lh-32">学生姓名：</div>
                    <el-input v-model="val" style="width: 150px;" placeholder="请输入学生姓名" clearable></el-input>
                </el-col>

                <el-col :span="6" :offset="3">
                    <div class="box box-align-center box-pack-end mt-btns">
                        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                        <el-button plain icon="el-icon-refresh" @click="search('refresh')">重置</el-button>
                    </div>
                </el-col>
            </el-row>
            <dyTable v-if="studentList.length > 0" ref="table" :columns="addColumns" :table-data="studentList"
                v-loading="tableLoading" :total="total" :page-num="pageNo" :page-size="pageSize"
                @current-change="pageNoChange" element-loading-text="加载中">
            </dyTable>


            <div class="flex jc-fe">
                <el-button type="primary" plain>确定</el-button>
                <el-button plain>取消</el-button>
            </div>
        </el-dialog>


        <el-dialog title="组员详情" :visible.sync="infoDialog" width="80%">
            <el-row class="mb-20">
                <el-col :span="3">
                    <div class="t-r pr-5 lh-32">学生真实姓名：</div>
                </el-col>
                <el-col :span="5">
                    <el-input v-model="val" style="width: 150px;" placeholder="" clearable></el-input>
                </el-col>
                <el-col :span="3">
                    <div class="t-r pr-5 lh-32">手机号：</div>
                </el-col>
                <el-col :span="5">
                    <el-input v-model="val" style="width: 150px;" placeholder="" clearable></el-input>
                </el-col>
                <el-col :span="3">
                    <div class="t-r pr-5 lh-32">创建时间：</div>
                </el-col>
                <el-col :span="5">
                    <el-input v-model="val" style="width: 150px;" placeholder="" clearable></el-input>
                </el-col>
            </el-row>
            <el-row class="mb-20">
                <el-col :span="3">
                    <div class="t-r pr-5 lh-32">昵称：</div>
                </el-col>
                <el-col :span="5">
                    <el-input v-model="val" style="width: 150px;" placeholder="" clearable></el-input>
                </el-col>
                <el-col :span="3">
                    <div class="t-r pr-5 lh-32">性别：</div>
                </el-col>
                <el-col :span="5">
                    <el-input v-model="val" style="width: 150px;" placeholder="" clearable></el-input>
                </el-col>
                <el-col :span="3">
                    <div class="t-r pr-5 lh-32">生日：</div>
                </el-col>
                <el-col :span="5">
                    <el-input v-model="val" style="width: 150px;" placeholder="" clearable></el-input>
                </el-col>
            </el-row>
            <div>
                <div v-for="i in 4" :key="i" class="flex jc-sb pb-20">
                    <div>学习“xxx”课程</div>
                    <div>2025-01-15 14:24:33</div>
                </div>
            </div>
            <div class="flex jc-fe">
                <!-- <el-button type="primary" plain>确定</el-button> -->
                <el-button plain>取消</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>
import { queryUserInfo, findAllSchool, updateUserDetail, queryUserDetails } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import dyTable from '@/components/common/dytable'


export default {
    name: 'approvalList',
    components: {
        dyTable
    },
    data() {
        return {
            loading: false,

            tableLoading: false,
            infoDialog: false,
            addDialog: false,

            val: "",
            columns: [],
            studentList: [{}],
            pageNo: 1,
            pageSize: 10,
            total: 100,

            addColumns: [],




        };
    },
    mounted() {
        this.columns = [
            {
                type: 'index',
                title: '序号'
            },
            {
                key: 'textName',
                title: '小组名称'
            },
            {
                key: 'textName',
                title: '学号'
            },
            {
                key: 'bgUserName',
                title: '加入时间'
            },
            {
                key: 'bgUserName',
                title: '注册状态'
            },
            {
                key: '',
                title: '操作',
                width: 200,
                render: ({ row }) => {
                    return (
                        <div>
                            <el-link type="primary" onClick={() => this.infoDialogOpen(row)}>详情</el-link>
                            <el-link type="danger" style="margin-left:12px" onClick={() => this.delete(row)}>移除</el-link>
                        </div>
                    );
                }
            },
        ];

        this.addColumns = [
            {
                type: 'index',
                title: '序号'
            },
            {
                key: 'textName',
                title: '学生姓名'
            },
            {
                key: 'textName',
                title: '学号'
            },
            {
                key: 'bgUserName',
                title: '身份信息'
            },
            {
                key: 'bgUserName',
                title: '加入时间'
            },

        ];

    },
    computed: {

    },
    methods: {

        pageNoChange() {

        },

        infoDialogOpen() {
            this.infoDialog = true;
        },

        addDialogOpen() {
            this.addDialog = true;
        },
        member() {

        },


        search(msg) {
            // if (msg == "refresh") {
            //     this.className = null;
            //     this.classId = null;
            // }
            // let form = {
            //     className: this.className,
            //     classId: this.classId,
            //     page: 1,
            // }
            this.getList(form)
        },
        getList(form) {
            // this.loading = true;
            // let info = {
            //     page: this.pageNo,
            //     pageSize: this.pageSize,
            //     ...form
            // };
            // console.log('info :>> ', info);
            // var data = encrypt(JSON.stringify(info));
            // getTextList(data).then((res) => {
            //     if (res.result == 1) {
            //         var ress = JSON.parse(decrypt(res.data));
            //         this.total = ress.total;
            //         this.pageNo = ress.pageNo;
            //         this.textList = ress.list;
            //         this.tableLoading = false;

            //         this.textList.forEach(e => {
            //             if (e.publishStatus == 2) {
            //                 e.publishStatus = 0
            //             }
            //         })

            //         console.log('textList :>> ', this.textList);

            //     } else {
            //         this.$message({
            //             showClose: true,
            //             message: res.msg,
            //             type: 'error'
            //         });
            //     }
            // });
        },


    }
};
</script>

<style lang='scss' scoped></style>
